import { mapFirebaseError, type AppError } from './firebaseErrors';

export interface BackendGatewayError {
  operation: string;
  reason: string;
  message?: string;
  messageKey?: string;
  messageParams?: Record<string, string | number | boolean>;
  original?: unknown;
}

export function isBackendGatewayError(error: unknown): error is BackendGatewayError {
  return (
    error !== null &&
    typeof error === 'object' &&
    'operation' in error &&
    'reason' in error &&
    typeof (error as BackendGatewayError).operation === 'string' &&
    typeof (error as BackendGatewayError).reason === 'string'
  );
}

export function toAppError(error: unknown, fallbackCode?: string): AppError {
  if (isBackendGatewayError(error)) {
    const code = `${error.operation}/${error.reason}`;
    const mappedError = mapFirebaseError(error.original, code);

    return {
      code,
      reason: error.reason,
      message: error.message || mappedError.message,
      messageKey: error.messageKey || mappedError.messageKey,
      messageParams: error.messageParams || mappedError.messageParams,
    };
  }

  return mapFirebaseError(error, fallbackCode);
}

export function createBackendGatewayError(
  operation: string,
  reason: string,
  original: unknown
): BackendGatewayError {
  const code = `${operation}/${reason}`;
  const mappedError = mapFirebaseError(original, code);

  return {
    operation,
    reason,
    message: mappedError.message,
    messageKey: mappedError.messageKey,
    messageParams: mappedError.messageParams,
    original,
  };
}
